// remainingTime filter -- formats a number of milliseconds into a human-readable (and not overly-precise) form
angular.module('app.filters').filter('remainingTime', ($filter) => {
  'ngInject';
  return (ms) => {
    let rt = $filter('relativeTime')(new Date(Date.now() + ms));
    if (rt.indexOf('ago') != -1) {
      rt = 'in a few seconds';
    } else if (rt.startsWith('in ') && !rt.startsWith('in a few')) {
      rt = rt.replace(/^in /, 'in about ');
    }
    rt = rt.replace(/^in /, '');
    return rt;
  };
});



// WEBPACK FOOTER //
// ./app/filters/remaining-time.js